import { lazy } from "react";

export const NewsDetailsAsync = lazy(() => import("./NewsDetails"));
